import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import {
  selectHasAssetBucketing,
  selectHasMobileNavigation,
} from '../../../../../../CommonSelectors/CommonAreaSelector';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';
import { WorkflowIdEnum } from '../../../../../../Workflow/api/useWorkflowDataQuery';
import { useClientId } from '../../../../../../_hooks/useClientId';
import { usePLDCardQuery } from '../../../../../api/usePLDCardQuery';
import { GoalCard } from '../GoalCard/GoalCard';
import { GoalCardError } from '../GoalCard/GoalCard.error';
import { GoalCardLoading } from '../GoalCard/GoalCard.loading';

export const PLDCard = () => {
  const hasAssetBucketing = useSelector(selectHasAssetBucketing);

  if (!hasAssetBucketing) {
    return null;
  }

  return <Card />;
};

const Card = () => {
  const { data, isLoading, error, refetch } = usePLDCardQuery();

  const clientId = useClientId();

  const hasMobileNavigation = useSelector(selectHasMobileNavigation);

  if (isLoading) {
    return <GoalCardLoading />;
  }

  if (error) {
    return <GoalCardError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  return (
    <GoalCard
      title={data.headline}
      icon={<Icon className="far fa-envelope-open-dollar" fontSize="h3" color="neutral.500" />}
      ctaText={data.isEmpty ? 'Complete Workflow' : 'View your Result'}
      hideFooter={hasMobileNavigation}
      onClick={() => {
        if (!hasMobileNavigation) {
          if (data?.isEmpty) {
            ADV.util.Router.go2('Workflow', {
              clientId,
              workflowId: WorkflowIdEnum.AssetBucketing,
              stepId: 0,
              pivotId: 0,
              pageId: 'start',
            });
          } else {
            ADV.util.Router.go2('AssetBucketingResults', {
              clientId,
              year: new Date().getFullYear(),
            });
          }
        }
      }}
    >
      <>
        {data.isEmpty ? (
          <Text>
            Once you have added accounts, other assets and provided some planning information, you
            can return here to see your results and visualize your net worth.
          </Text>
        ) : (
          <Box
            mb="8"
            as="ul"
            css="list-style: none"
            p="0"
            display="flex"
            flexDirection="column"
            style={{ gap: 8 }}
            mt="8"
          >
            {data.buckets.map(bucket => (
              <Box key={bucket.bucketName} as="li" display="flex" justifyContent="space-between">
                <Text css="flex-basis: 50%" isTruncated>
                  {bucket.bucketName}
                </Text>

                <Text fontWeight={500}>{formatCurrency(bucket.total)}</Text>
              </Box>
            ))}
          </Box>
        )}
      </>
    </GoalCard>
  );
};
